// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"e5f2c428","643":"c243dabe","696":"2739fcb7"}[chunkId] + ".chunk.js";
};